import { richTooltips } from '@dha-nexus/shared';
import { RichTooltipCard } from '../richTooltips/RichTooltipCard.jsx';

const { RICH_TOOLTIP_INTERACTION_MODES, RICH_TOOLTIP_VARIANTS } = richTooltips;

function normalizeHeatmapCellToRichTooltip(cell) {
  if (!cell) return null;
  return {
    surfaceId: cell.cellId || `${cell.portfolioId}:${cell.dimensionKey}`,
    variant: RICH_TOOLTIP_VARIANTS.STANDARD,
    interactionMode: RICH_TOOLTIP_INTERACTION_MODES.PINNABLE,
    entityLabel: cell.portfolioLabel,
    sliceLabel: cell.dimensionLabel,
    headlineValue: {
      primary: `Score ${cell.score}`,
      secondary: null,
      tone: cell.tone || 'slate',
    },
    summary: cell.summary,
    drivers: cell.drivers || [],
    formula: cell.formula?.ruleLabel
      ? {
          ruleLabel: cell.formula.ruleLabel,
          weightedInputs: cell.formula.weightedInputs || [],
        }
      : null,
    trust: {
      sourceSystems: cell.trust?.sourceSystems || [],
      lastUpdatedAt: cell.trust?.lastUpdatedAt || null,
      freshness: cell.trust?.freshness || 'unknown',
      confidence: cell.trust?.confidence ?? null,
      manualOverride: Boolean(cell.trust?.manualOverride),
      warnings: [...(cell.trust?.warnings || []), ...(cell.limitations || [])],
    },
    limitations: cell.limitations || [],
    drillTarget: cell.drillTarget?.href
      ? {
          kind: cell.drillTarget.kind || 'route',
          label: cell.drillTarget.label,
          href: cell.drillTarget.href,
        }
      : null,
  };
}

export function HeatmapTooltipCard({
  cell,
  payload: payloadProp,
  surfaceKind = 'cell',
  open,
  pinned,
  anchorRect,
  containerBounds,
  linkRef,
  tooltipRef,
  onMouseEnter,
  onMouseLeave,
  onRequestClose,
}) {
  // A header surface passes a prebuilt RichTooltip payload; a cell passes the raw
  // cell and we normalize it here.
  const payload = payloadProp || (cell ? normalizeHeatmapCellToRichTooltip(cell) : null);
  if (!open || !payload || !anchorRect) return null;

  const absoluteAnchorRect = {
    left: anchorRect.left + (containerBounds?.offsetLeft || 0),
    top: anchorRect.top + (containerBounds?.offsetTop || 0),
    width: anchorRect.width,
    height: anchorRect.height,
  };

  return (
    <RichTooltipCard
      payload={payload}
      open={open}
      pinned={pinned}
      anchorRect={absoluteAnchorRect}
      testIdPrefix="heatmap-tooltip"
      dataSurface={surfaceKind}
      linkRef={linkRef}
      tooltipRef={tooltipRef}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onRequestClose={onRequestClose}
    />
  );
}
